import { render } from "./CaptainPicker.vue?vue&type=template&id=ca41b076"
import script from "./CaptainPicker.vue?vue&type=script&lang=js"
export * from "./CaptainPicker.vue?vue&type=script&lang=js"
script.render = render

export default script